export default __webpack_public_path__ + "static/header-marketing-7902ca64877a2442941a3b31fad5376a.png";